// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__17V2C","cell":"ColumnAccessor_cell__3z0gK","firstCellAccent":"ColumnAccessor_firstCellAccent__18L5z"};